import React from "react";

const Destination =(props)=> {
return(
    <>
    <div  style={{
        backgroundImage: `url(${props.img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}

      className="destination-image"
    >
      <h1>{props.place}</h1>
    </div>

    </>
);
}

export default Destination;